<template>
  <div>
        <div class="row justify-content-center" >
            <div class="col-md-5">
                <br>
                <div class="col-md-11">
                    <img src="fotos/notificacion.png" style="width: 150px; margin-left: -220px;" >
                </div>
                <div class="row justify-content-center" style="margin-top: -150px;">
                   <div class="col-md-8 mt-5"  v-for="eje in arrayEje" :key="eje.id" v-show="seccion == 0">
                       
                       
                       <b-card style="border-radius: 20px;">
                            <b-card-text>
                            <div class="row justify-content-center"  >
                                <div class="col-md-3">
                                    <img src="icon/usern.png" width="80"> 
                                </div>
                                <div class="col-md-9">
                                    <b>Ejecutivo: {{eje.ejecutivo}}</b>
                                    <p>Total registros: <span style="color:#F63BFF;">{{eje.total}}</span></p>
                                </div>    
                                <div class="col-md-6"></div>
                                <div class="col-md-6">
                                    <button  type="button" class="btn-sm btn btn-outline-dark position-relative"  @click="abrirModal(eje.axc)">
                                        Mensajes
                                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" >
                                           {{eje.mensajes}}
                                        </span>
                                    </button>
                                    <!-- <b-button variant="outline-dark"  size="sm" @click="abrirModal(eje.axc)">
                                        Mensajes
                                    </b-button> -->
                                    <b-button variant="outline-dark" class="ml-2" size="sm" @click="verDetalle(eje.axc)">
                                        Detalles
                                    </b-button>
                                </div>                        
                            </div>
                            </b-card-text>
                        </b-card>
                        

                    </div>
                    <div class="col-md-12" v-if="arrayEje.length == 0 && seccion == 0" style="background: #FCFCFC; box-shadow: inset 0 0 10px 0 #CDCDCD;">
                        <center>
                          <br>
                          <h4 style="color:#098FD6; marg">Nada que mostrar.</h4> 
                          <br>
                        </center>
                    </div>
                    <div class="col-md-12" v-if="seccion == 1" >
                        <u style="color:#039cf3; cursor: pointer;" @click="seccion = 0">Regresar</u>
                        <div class="table-responsive">
                            <table class="table table-hover table-striped mt-3" style="">
                                <thead class=" text-white" style=" background: #039cf3;">
                                <tr>
                                    <th scope="col">Captura</th>
                                    <th scope="col">Tipo de Venta</th>
                                    <th scope="col">Imei</th>
                                    <th scope="col">Marca</th>
                                    <th scope="col">Costo</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="det in arrayDetalle" :key="det.id">
                                    <td>{{det.created_at | fechaA}}</td>
                                    <td>{{det.tipo_venta}}</td>
                                    <td>{{det.imei}}</td>
                                    <td>{{det.marca}}</td>
                                    <td>$ {{formatPrice(det.costo)}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <br>
                <hr style="border-top: 5px solid #60CD31 !important;  opacity :0.8;">    
                <br><br><br>
            </div>
         </div>

         <b-modal id="enviarMensaje" title="Enviar Mensaje" size="lg" hide-footer header-close-content="Cerrar">

            <div class="row  justify-content-center">
                <div :class="isMobile ? 'col-12 mt-2' : 'col-md-7 text-left'" >
                <b-form-input placeholder="Mensaje" v-model="mensaje"   type="text" style="border-radius: 6px; box-shadow: inset 0 0 10px 0 #CDCDCD;" class="mt-3"/>            
                </div>
                <div class="col-md-2 mt-3">
                    <b-button block variant="primary" @click="enviaMensaje()">Enviar <b-spinner small v-if="loader"></b-spinner> </b-button>
                </div>
                <div class="col-md-10 mt-3">
                    <hr style="border-top: 5px solid #60CD31 !important;  opacity :0.8;">  
                </div>
            </div>
            <div class="text-left">
                <div id="global" class="mt-3">
                    <div id="mensajes" v-for="com in arrayComent" :key="com.id">
                        <div class="texto">
                            <b><b-avatar :style="com.perfil == 3 ? 'background: #3ABF30;' : 'background: #098FD6;'" size="sm"></b-avatar>
                            <template v-if="com.perfil == 3"> Gerente</template>
                            <template v-if="com.perfil == 7"> Ejecutivo de Ventas</template>
                            </b>
                            <div class="row">
                                <div class="col-1"></div>
                                <div class="col-11 col-lg-12">
                                    <p :style="!isMobile ? 'text-indent: 1.7em;' : ''">{{com.contenido}} <em style="font-size:small;">({{com.created_at | fechaA}}) </em></p> 
                                </div>
                            </div>
                        </div>                             
                    </div>
                </div>
            </div>                       
         </b-modal>

  </div>
</template>

<script>
import moment from 'moment';
import Swal from 'sweetalert2'
export default {
    name:"NotificacionGerente",
    data() {
      return {
        seccion:0,
        arrayEje:[],
        arrayDetalle:[],
        loader:false,
        mensaje:"",
        isMobile: this.$mobile(),
        arrayComent:[],
        axc:""
      }
    },
    computed: {
        user() {
           return this.$store.getters.getInfoUser;
        },
    },
    filters: {
        fechaA:function(value) {
            if (value) {
                moment.locale('es')
                return moment(String(value)).format('YYYY-MM-DD h:mm:ss a')
            }
        }
    },
    methods:{
      getNoti(){
        var url= 'cantado/ejecutivos?idpdv='+ this.user.id_pdv;
            this.$api.get(url).then(
                ({data}) => {
                    console.log(data);
                    this.arrayEje = data.data.ejecutivos;
               
                }
            );
      },
      verDetalle(id){
         var url= 'cantado/detalle?idpdv='+ this.user.id_pdv + '&axc=' + id;
            this.$api.get(url).then(
                ({data}) => {
                    console.log(data);
                    this.arrayDetalle = data.data.detalles;   
                    this.seccion = 1;            
                }
            );
      },
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace(",", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      enviaMensaje(){
        if (!this.mensaje) {
            Swal.fire({
                icon: 'error',
                title: 'Ingrese Mensaje.',
                text: 'Campo requerido.'
            })
        } else {
            this.loader = true;
          var url= 'cantado/mensaje?idpdv='+ this.user.id_pdv + '&axc=' + this.axc + '&gerente=' + this.user.mrt + '&perfil=' + this.user.perfiles[0].perfil.id + '&mensaje=' + this.mensaje;
            this.$api.get(url).then(
                ({data}) => {
                    console.log(data);
                    this.mensaje = "";
                    this.arrayComent = data.data.comentario;    
                    this.loader = false;
                       Swal.fire(
                        "List@",
                        "Correo enviado exitosamente.",
                        'success'
                        )  
                }
            );
        }
      },
      abrirModal(id){
        this.axc = id;
        var url= 'cantado/historial?idpdv='+ this.user.id_pdv + '&axc=' + id + '&gerente=' + this.user.mrt;
            this.$api.get(url).then(
                ({data}) => {
                    console.log(data);
                    this.arrayComent = data.data.comentario;    
                    this.$bvModal.show('enviarMensaje') 
                }
            );       
      }
    },
    mounted(){
        this.getNoti();
    }
}
</script>

<style>
.bg-primary2{
  background: #039CF3;
}

#global {
	height: 320px;
	width: 100%;
	border: 1px solid #ddd;
	background: #f1f1f1;
	overflow-y: scroll;
}
#mensajes {
	height: auto;
}
.texto {
	padding:4px;
	background:#fff;
}
</style>